import React from 'react';
import './styles.css';
import ReactDOM from 'react-dom';
import Random from '../../utils/strings/Random';

class AlertBox extends React.Component{
  constructor(props) {
    super(props);
    this.MODAL_CLASS_IN = "__react-alert-in__";

    this.handleKeyUp = this.handleKeyUp.bind(this);
    this.handlerClose = this.handlerClose.bind(this);
    this.close = this.close.bind(this);
  }

  componentDidMount() {
    this.addClassAlertIn();
    window.addEventListener('keyup', this.handleKeyUp, false);
  }

//
  close(){
    this.closeAlert();
  }

//bt close handler
  handlerClose (e){
    this.closeAlert();
  }

//add class MODAL_CLASS_IN to body and make overflow hidden to prevent page scrolling
  addClassAlertIn (){
    var _body = document.body;
    _body.classList ? _body.classList.add(this.MODAL_CLASS_IN) : _body.className += ' '+this.MODAL_CLASS_IN;
  }

//remove class MODAL_CLASS_IN to body and make overflow hidden to prevent page scrolling
  removeClassIn (){
    var _body = document.body;
    _body.classList.remove(this.MODAL_CLASS_IN);
  }

//esc key remove alert
  handleKeyUp(e) {
    const keys = {
      27: () => {
        e.preventDefault();
        this.closeAlert();
        window.removeEventListener('keyup', this.handleKeyUp, false);
      },
    };

    if (keys[e.keyCode]) { keys[e.keyCode](); }
  }

//close alert
  closeAlert (){
    var _id = this.props.id;
    var elem = document.getElementById(_id);
    elem.parentNode.removeChild(elem);
    this.removeClassIn();
  }

  render () {
    return (
        <div className="__alert__">
          <div className="__alert-box__">
            <button onClick={this.handlerClose} className="__alert-button-close__"><i className="fas fa-times"></i></button>
            <div className="__alert-box-inner__">
            {this.props.page}
            </div>
          </div>
        </div>
    );
  }
};

const MODAL_CLASS_WRAPPER = "__react-alert-class__";


class Alert {
  constructor(__args__) {
    //this.init(__args__);

  }
  static ANIMATION_INCREASE = "increase";

  close (){
    this.alert.close();
  }

  open(__props__){
    //create an element that will create our overlay
    const container = document.createElement("div");
    var _randomId = Random(5);
    container.setAttribute("id", _randomId);
    container.setAttribute("class", MODAL_CLASS_WRAPPER);
    document.body.appendChild(container);
    container.classList.add("open");

    setTimeout(function(){
      container.classList.add(__props__.animation);
    },1);

    var overlay = ReactDOM.render(<AlertBox  id={_randomId} page={__props__.page} />, document.getElementById(_randomId));
    this.alert = overlay;
  }
}

export default Alert;



// WEBPACK FOOTER //
// ./src/components/alert/Alert.js